import React from 'react';
import { Loader } from '../StartApplication/StartApplication.loader';
import { ComplianceForm } from './ComplianceForm';
import RentersInsuranceLayout from '../../layouts/RentersInsuranceLayout';
import { useNewFlowFeatureFlag } from './hooks/useNewFlowFeatureFlag';
import { ROUTES } from '../../constants/routes';
import { useNavigate } from 'react-router-dom';
import { useLocationSearch } from '../../helpers/hooks/useLocationSearch';

const ComplianceFormContainer = () => {
  const { loadingStatus, ren1402_newFlow } = useNewFlowFeatureFlag();
  const getUrlWithQueryParams = useLocationSearch();
  const navigate = useNavigate();

  if (loadingStatus === 'pending') {
    return <Loader />;
  }

  const handleBackButtonClick = () => {
    navigate(getUrlWithQueryParams(ROUTES.COMPLIANCE_WELCOME_PATH));
  }

  return (
    <RentersInsuranceLayout
      progressBarProps={{ progress: '25%' }}
      headerProps={{
        v2: true,
        backButtonAction: handleBackButtonClick,
      }}
    >
      <ComplianceForm ren1402_newFlow={ren1402_newFlow}/>
    </RentersInsuranceLayout>
  );
};

export default ComplianceFormContainer;
